// Конфигурация WebSocket URL
// Формируется из базового URL из env: process.env.REACT_APP_WS_URL
export const url: any = process.env.REACT_APP_WS_URL;
export const wsUrl: string = `${url}/api/v1/ws`;

// Конфигурация WebSocket URL
// Базовый URL берём из env, а если он не задан (dev) — подключаемся к dev-серверу,
// чтобы запрос ушёл через CRA proxy (как и обычные HTTP-запросы).
// const envBase = (process.env.REACT_APP_WS_URL || "").trim();

// const normalizeBase = (base: string) => base.replace(/\/+$/, "");

// const toWebSocketBase = (base: string) => {
// 	if (!base) return "";
// 	if (base.startsWith("ws://") || base.startsWith("wss://")) return base;
// 	if (base.startsWith("http://")) return `ws://${base.slice("http://".length)}`;
// 	if (base.startsWith("https://"))
// 		return `wss://${base.slice("https://".length)}`;
// 	return base;
// };

// const fallbackBase =
// 	typeof window !== "undefined" ? toWebSocketBase(window.location.origin) : "";

// export const wsBaseUrl: string = normalizeBase(
// 	toWebSocketBase(envBase) || fallbackBase,
// );

// export const wsUrl: string = `${wsBaseUrl}/api/v1/ws`;
